/**
 * Summarise the evidence sources behind a speaker-name suggestion into a short,
 * translated human string ("self-introduction, voice match ×2").
 *
 * Extracted verbatim (same msgids) from `SpeakerHypothesisPillsView` so every
 * future consumer of the post-meeting suggestion review renders the same
 * evidence copy. Pure — takes the sources and the active `i18n`, returns a
 * ready-to-render string ("" when there is nothing to say).
 */

import type { I18n } from "@lingui/core"
import { msg } from "@lingui/core/macro"

export function summariseSpeakerEvidence(sources: string[], i18n: I18n): string {
  if (sources.length === 0) return ""
  const counts = new Map<string, number>()
  for (const s of sources) counts.set(s, (counts.get(s) ?? 0) + 1)
  const labels: Record<string, string> = {
    intro: i18n._(msg`self-introduction`),
    "address-response": i18n._(msg`addressed by name`),
    voiceprint: i18n._(msg`voice match`),
    "user-confirm": i18n._(msg`you confirmed`),
    "user-reject": i18n._(msg`you rejected`),
    "llm-resolution": i18n._(msg`transcript context`),
    "analysis-attendee": i18n._(msg`meeting analysis`),
    "live-hypothesis": i18n._(msg`live session signals`),
  }
  return [...counts.entries()].map(([k, n]) => (n > 1 ? `${labels[k] ?? k} ×${n}` : (labels[k] ?? k))).join(", ")
}
